function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_sn_sub:customdeploy_create_subscription":"/app/site/hosting/scriptlet.nl?script=3751&deploy=1&compid=4978786&ns-at=AAEJ7tMQRs-XuIRQ6GBjPv0Lp0JmAM-JjgTJ7UlaQNitUy6Xp68","customscript_ns_sc_sl_sn_get_subs:customdeploy_ns_sc_sl_sn_get_subs":"/app/site/hosting/scriptlet.nl?script=3750&deploy=1&compid=4978786&ns-at=AAEJ7tMQuKKDcPTZziFuOI64Fon4YTM09c6a-XppTK2DkVxXXY4","customscript_ns_sc_sl_sn_isb:customdeploy_ns_sc_sl_sn_isb":"/app/site/hosting/scriptlet.nl?script=4054&deploy=1&compid=4978786&ns-at=AAEJ7tMQoN5f9mdF-v2wo9ysB7NXrj6w9rnFEKLxRm_L1cvxcSM","customscript_ns_sc_sl_sn_subswitch:customdeploy_ns_sc_sl_sn_subswitch":"/app/site/hosting/scriptlet.nl?script=3749&deploy=1&compid=4978786&ns-at=AAEJ7tMQGDhiAyJSA1Teqjlg66jsZyleZjMj5p5oI456z167Wzk"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}